module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921073834_T.8b255a48.jpg";